import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

const PriceChart = ({ data, timeFrame = '1D' }) => {
    // Mock data if none provided
    const chartData = data || Array.from({ length: 24 }, (_, i) => ({
        timestamp: Date.now() - (23 - i) * 3600000,
        price: 0.45 + Math.random() * 0.1,
        volume: Math.floor(Math.random() * 10000)
    }));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-background/95 border border-white/10 p-3 rounded-lg backdrop-blur text-xs">
                    <p className="text-muted-foreground mb-1">{format(label, 'MMM dd HH:mm')}</p>
                    <p className="text-emerald-400 font-bold text-lg">
                        ${payload[0].value.toFixed(2)}
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="w-full h-full min-h-[300px] bg-white/[0.02] border border-white/10 rounded-xl p-4">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm font-bold text-muted-foreground">Price History</h3>
                <div className="flex gap-2">
                    {['1H', '4H', '1D', '1W'].map((tf) => (
                        <button
                            key={tf}
                            className={`px-3 py-1 text-xs rounded-md transition-colors ${timeFrame === tf
                                    ? 'bg-emerald-500 text-white'
                                    : 'text-muted-foreground hover:bg-white/5'
                                }`}
                        >
                            {tf}
                        </button>
                    ))}
                </div>
            </div>

            <div className="h-[250px] w-full">
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={chartData}>
                        <defs>
                            <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
                                <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
                        <XAxis
                            dataKey="timestamp"
                            tickFormatter={(ts) => format(ts, 'HH:mm')}
                            stroke="#525252"
                            fontSize={10}
                            tickLine={false}
                            axisLine={false}
                        />
                        <YAxis
                            domain={['auto', 'auto']}
                            stroke="#525252"
                            fontSize={10}
                            tickLine={false}
                            axisLine={false}
                            tickFormatter={(val) => `$${val.toFixed(2)}`}
                            orientation="right"
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                            type="monotone"
                            dataKey="price"
                            stroke="#10b981"
                            strokeWidth={2}
                            fillOpacity={1}
                            fill="url(#colorPrice)"
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>

            <div className="flex justify-between items-center mt-2 px-2">
                <div className="text-xs text-muted-foreground">
                    <span className="font-bold text-white block">$71.8M</span>
                    Volume
                </div>
                <div className="text-xs text-muted-foreground text-center">
                    <span className="font-bold text-white block">$936.5K</span>
                    Liquidity
                </div>
                <div className="text-xs text-muted-foreground text-right">
                    <span className="font-bold text-emerald-400 block">+3.2%</span>
                    24h Change
                </div>
            </div>
        </div>
    );
};

export default PriceChart;
